import React from "react";
import { NavLink } from "react-router-dom";

/**
 * CandidateSubNav - Navigation component for main candidate sections
 *
 * In create mode (isCreating=true):
 * - Only Personal section is shown (other sections hidden in CandidateLayout)
 *
 * In edit mode (isCreating=false):
 * - All sections are visible and accessible
 */
const CandidateSubNav = ({ name, link }) => {
  // Base styles
  const baseStyles = "p-2 rounded-tl-lg rounded-tr-lg justify-start items-center flex text-sm font-normal leading-tight tracking-tight gap-1 transition-all duration-200";

  // Active styles
  const activeStyles = "bg-primary-500 text-white";

  // Inactive but accessible styles
  const inactiveStyles = "text-neutral-500 hover:text-primary-400";

  return (
    <NavLink
      to={link}
      className={({ isActive }) => {
        return isActive
          ? `${baseStyles} ${activeStyles}`
          : `${baseStyles} ${inactiveStyles}`;
      }}
    >
      {name}
    </NavLink>
  );
};

export default CandidateSubNav;
